/** What spends credits, as a writer's usage shows. */
export const CREDIT_ACTIVITIES = ['rewrite', 'tool', 'dictation', 'speech', 'imageText'] as const;
export type CreditActivity = (typeof CREDIT_ACTIVITIES)[number];

/** Credits spent from the same daily allowance on every plan. */
export const CREDIT_RATES = {
  rewritePerWord: 1,
  transcriptionPerSecond: 5,
  /** Reading an image's text or describing it: most of the work is the image, not the words. */
  imagePerImage: 40,
  speechPerWord: 20,
  /** AI tools, such as Bullet points or the writer's own, per word of the text they format. */
  toolPerWord: 2,
} as const;
